import React from "react";

interface IconThemePreviewBaseProps {
  children: React.ReactNode;
  sidebarPathFill?: string;
  maskContent?: React.ReactNode;
}

const IconThemePreviewBase: React.FC<IconThemePreviewBaseProps> = ({
  children,
  sidebarPathFill = "Currentcolor",
  maskContent,
}) => (
  <span className="anticon anticon-themebase">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="190"
      height="137"
      fill="none"
      viewBox="0 0 190 137"
    >
      <rect
        width="189"
        height="136"
        x="0.5"
        y="0.5"
        fill="#fff"
        stroke="#ECEEF5"
        rx="4.5"
      />
      <path fill="#F7FAFD" d="M54 136h132a3 3 0 003-3V14H54v122z" />
      <g filter="url(#filter0_d)">
        <path
          fill="#fff"
          d="M1 11C1 5.477 5.477 1 11 1h168c5.523 0 10 4.477 10 10v4H1v-4z"
        />
      </g>
      <path fill={sidebarPathFill} d="M16 136H4a3 3 0 01-3-3V15h15v121z" />
      <circle cx="6" cy="8" r="2" fill="#CC6B65" />
      <circle cx="13" cy="8" r="2" fill="#FDBF00" />
      <circle cx="20" cy="8" r="2" fill="#51A121" />
      <rect width="24" height="6" x="59" y="20" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="20" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="20" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="29" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="29" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="38" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="38" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="47" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="47" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="56" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="56" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="65" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="65" fill="#ECF1F5" rx="1" />
      <rect width="5" height="5" x="6" y="74" fill="#E2F6FF" rx="1" />
      <rect width="27" height="5" x="21" y="74" fill="#ECF1F5" rx="1" />
      {children}
      {maskContent}
      <defs>
        <filter
          id="filter0_d"
          width="190"
          height="16"
          x="0"
          y="1"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </span>
);

export default IconThemePreviewBase; 